import * as React from 'react';
export var NestingContext = /*#__PURE__*/React.createContext(null);
//# sourceMappingURL=NestingContext.js.map
